import { useFreelancerProfile } from "@js/apps/freelancer/hooks";
import { useAppSelector } from "@js/hooks/redux";
import type { Freelancer } from "@js/types/freelancer";

export const useUserNeedsIdentityVerification = () => {
  const freelancer = useFreelancerProfile();
  const fetchingFreelancerProfile = useAppSelector(
    (state) => state.freelancer.fetchingFreelancerProfile,
  );

  return {
    isLoading: fetchingFreelancerProfile,
    userNeedsIdentityVerification: getUserNeedsIdentityVerification({
      freelancer: freelancer ?? null,
    }),
    userFailedIdentityVerification: getUserFailedIdentityVerification({
      freelancer: freelancer ?? null,
    }),
  };
};

const IDV_REQUIRED_STATUSES: Array<
  EnumType<typeof ENUMS.IdentityVerificationStatuses>
> = [
  ENUMS.IdentityVerificationStatuses.CREATED,
  ENUMS.IdentityVerificationStatuses.PENDING,
  ENUMS.IdentityVerificationStatuses.EXPIRED,
];

export const getUserNeedsIdentityVerification = ({
  freelancer,
}: {
  freelancer: Pick<Freelancer, "idv_status"> | null;
}) => {
  return (
    !!freelancer?.idv_status &&
    IDV_REQUIRED_STATUSES.includes(freelancer.idv_status)
  );
};

export const getUserFailedIdentityVerification = ({
  freelancer,
}: {
  freelancer: Pick<Freelancer, "idv_status"> | null;
}) => {
  return freelancer?.idv_status === ENUMS.IdentityVerificationStatuses.FAILED;
};
